function Directive() {
  return {
    restrict: 'A',
    priority: 1,
    require: 'ngModel',
    link(scope, element, attr, ngModelCtrl) {
      ngModelCtrl.$parsers.push(function(value) {
        if (value) {
          value = stripSymbols(value);
          parsePhoneNumber(value);
          return value;
        }

        return null;
      });

      ngModelCtrl.$formatters.push(function(value) {
        if (value) {
          value = stripSymbols(value);
          return parsePhoneNumber(value);
        }

        return null;
      });

      const stripSymbols = function(phoneNumber) {
        return phoneNumber.replace(/\D/g, '').trim();
      };

      const parsePhoneNumber = function(phoneNumber) {
        const original = phoneNumber;

        if (original.length >= 4) {
          phoneNumber = '(' + phoneNumber.substring(0, 3) + ')' + phoneNumber.substring(3, phoneNumber.length); //eslint-disable-line
        }
        if (original.length >= 4) {
          phoneNumber = phoneNumber.substring(0, 5) + ' ' + phoneNumber.substring(5, phoneNumber.length); //eslint-disable-line
        }
        if (original.length >= 7) {
          phoneNumber = phoneNumber.substring(0, 9) + '-' + phoneNumber.substring(9, phoneNumber.length); //eslint-disable-line
        }
        if (original.length >= 11) {
          phoneNumber = original;
        }

        ngModelCtrl.$viewValue = phoneNumber;
        ngModelCtrl.$render();

        return phoneNumber;
      };
    }
  };
}

Directive.$inject = [];

export default Directive;



// WEBPACK FOOTER //
// ./src/directives/phoneNumber/index.js